import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrackingRequirements extends Layout {
    panelTrackingRequirements: Panel;
    sourceMovement: DataSource;
    switchTrackingRequired: Switch;
    textboxCheckcallSchedId: Textbox;
    textboxGeoOverrideMins: Textbox;
    textboxRequiredVendor: Textbox;
}
